import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';
import { FIELD_CLASS } from './field.styles';

interface FormFieldFileProps {
    field: FormFieldDto;
}

export function FormFieldFile({ field }: FormFieldFileProps) {
    return <Input name={field.name} type="file" required={field.required} className={FIELD_CLASS} />;
}
